@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.dangerous-goods-type-field {
  font-weight: @normal;
}

.dropdown-menu {
  margin-left: @space-8;
}

.contact-field {
  display: flex;
  align-items: center;
  width: 100%;
  gap: @space-8;
  > label {
    flex: 0 0 auto;
  }
  > input {
    // there is no other way to override the margin in Input component
    margin-top: @space-0 !important;
  }
}

.contact-label {
  font-size: 14px;
  font-weight: @normal;
}
